module.exports = __webpack_public_path__ + "img/unlogged_side_menu.211867a1.png";